module.exports = {
  TrueFalse: {
    PluginName: "True/False",
    content_box_name: "Content ",
    Statement:
      "This is a True or False question. You can write here the general question statement here",
    Question: "Question",
    Answer: "Answer",
    Feedback: "Feedback",
    FeedbackMsg:
      "Here you can provide some feedback about the answer. In order to disable this feature, turn it off in the toolbar.",
    TrueFeedbackMsg:
      "Here you can provide some feedback about the true answer. In order to disable this feature, turn it off in the toolbar.",
    FalseFeedbackMsg:
      "Here you can provide some feedback about the false answer. In order to disable this feature, turn it off in the toolbar.",
    ShowFeedback: "Show feedback msg.",
    Number: "Number of statements",
    QuizColor: "Color",
    notCount: "This exercise does not add points",
    CheckAnswerText: "Check Answer Button Text",
    TryAgainText: "Try Again Button Text",
    SeeAnswerText: "See Answer Button Text",
    TrueText: "True Button Text",
    FalseText: "False Button Text",
    ButtonStyle: "Button Style",
    ButtonBackground: "Button Background Color",
    ButtonTextColor: "Button Text Color",
    ButtonBorderColor: "Button Border Color",
    ButtonBorderWidth: "Button Border Width",
    ButtonBorderRadius: "Button Border Radius",
    ButtonPadding: "Button Padding",
    ButtonFontSize: "Button Font Size",
    ButtonFontWeight: "Button Font Weight",
    ButtonHoverBackground: "Button Hover Background Color",
    TrueButtonStyle: "True Button Style",
    FalseButtonStyle: "False Button Style",
    tryAgain: "Try Again",
    checkAnswer: "Check Answer",
    True: "True",
    False: "False",
  },
};
